import Resource from '@/api/core/resource'

class Auth extends Resource {
  constructor () {
    super('auth')
  }

  logout () {
    return this.request.post(this.uri.concat('/logout'))
  }

  login (credenciales) {
    return this.request.post(this.uri.concat('/login'), credenciales)
  }

  usuario () {
    return this.request.get(this.uri.concat('/usuario'))
  }

  olvidePassword (credenciales) {
    return this.request.post(this.uri.concat('/olvide-password'), credenciales)
  }

  cambiarPassword (credenciales) {
    return this.request.post(this.uri.concat('/cambiar-password'), credenciales)
  }

  registrar (credenciales) {
    return this.request.post(this.uri.concat('/registrar'), credenciales)
  }

  acceso (credenciales) {
    return this.request.post(this.uri.concat('/acceso'), credenciales)
  }
}

export default new Auth()
